import useDialog from '@hooks/useDialog';
import { createContext, useState, useContext, useRef } from 'react'

const DrawerContext = createContext();
const DrawerProvider = ({ children }) => {
  const [isBottomDrawerOpen, openBottom, closeBottomDrawer] = useDialog('bottom_drawer', 'bottom-drawer-open')
  // const [bottomDrawerContents, setBottomDrawerContents] = useState()
  const bottomDrawerContents = useRef(null)
  const [isLeftDrawerOpen, openLeftDrawer, closeLeftDrawer] = useDialog('left_drawer', 'left-drawer-open')

  const rightDrawerContents = useRef(null)
  const [isRightDrawerOpen, openRight, closeRightDrawer] = useDialog('right_drawer', 'right-drawer-open')

  // NOTE: The bottom and drawers are special because the contents are interchangeable.
  const openWithContents = (contents, contentAccessorRef, openFunc) => {
    contentAccessorRef.current = contents
    openFunc()
  }

  const openBottomDrawer = (contents) => {
    openWithContents(contents, bottomDrawerContents, openBottom)
  }

  const openRightDrawer = (contents) => {
    openWithContents(contents, rightDrawerContents, openRight)
  }

  return (
    <DrawerContext.Provider value={{
      isBottomDrawerOpen,
      bottomDrawerContents,
      openBottomDrawer,
      closeBottomDrawer,

      isRightDrawerOpen,
      rightDrawerContents,
      openRightDrawer,
      closeRightDrawer,
      
      isLeftDrawerOpen,
      openLeftDrawer,
      closeLeftDrawer,
    }}>
      {children}
    </DrawerContext.Provider>
  )
}

const useDrawerContext = () => useContext(DrawerContext)

export default useDrawerContext

export { DrawerContext, DrawerProvider, useDrawerContext }
